import { DialogContent, DialogTitle, Switch } from "@mui/material";
import styles from "./CallForwardList.module.css";
import { ArrowLeft, Edit, Lock, Plus, Trash2, X } from "react-feather";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";

const CallForwardListing = (props) => {
  const { isAuthenticated, user } = useAuth0();

  console.log(props?.callForwardList);
  const handleToggle = (event, id) => {
    const isEnabling = event.target.checked; // true = trying to enable
    const callForwards = props?.callForwardList || [];
    console.log(isEnabling, id, callForwards);
    const toggledPhone = callForwards.find((phone) => {
      console.log(phone);
      return phone.id === id;
    });
    if (!toggledPhone) return;

    // Always allow disabling
    if (!isEnabling) {
      const data = { is_archived: 1 };
      props.updateCallForward(data, id);
      return;
    }

    // Skip restriction for primary
    if (toggledPhone.is_primary === 1) {
      const data = { is_archived: 0 };
      props.updateCallForward(data, id);
      return;
    }

    // Check for another non-primary enabled phone
    const anotherEnabled = callForwards.find(
      (phone) =>
        phone.id !== id && phone.is_primary === 0 && phone.is_archived === 0
    );

    if (anotherEnabled) {
      toast.error(
        "Only one number can be enabled at a time. Please disable the other number first."
      );
      return;
    }

    // Safe to enable
    const data = { is_archived: 0 };
    props.updateCallForward(data, id);
  }

  const isSMSChatCallforwardingCreate = isAuthenticated && user["https://propertydek.com/permissions"].indexOf("smschat-callforwarding:create") > -1;
  const isSMSChatCallforwardingUpdate = isAuthenticated && user["https://propertydek.com/permissions"].indexOf("smschat-callforwarding:update") > -1;
  const isSMSChatCallforwardingDelete = isAuthenticated && user["https://propertydek.com/permissions"].indexOf("smschat-callforwarding:delete") > -1;

  return (<>
    <DialogTitle id="alert-dialog-title" className={`${styles.CustomTitle}`}>
      <button className={`${styles.BackAddBU}`} onClick={(e) => props?.handleCloseModal(false)}>
        <ArrowLeft />
      </button>
      Add Number
      <button onClick={(e) => props?.handleCloseModal(false)} className={`${styles.ModalCloseBU}`}>
        <X />
      </button>
    </DialogTitle>
    <DialogContent className={`${styles.RequestBodyPop}`}>
      <div className={`${styles.PromptListMainSec}`}>
        <div className={`${styles.PromptListSearchSec}`}>
          {isSMSChatCallforwardingCreate && <button className={`${styles.AddPromptBU}`} onClick={() => props?.setIsShowAddEditForm(true)}>
            <Plus /> Number
          </button>}
        </div>
        {props?.callForwardList?.length > 0 && props?.callForwardList.map((callForward) => {
          return (<div key={callForward?.id} className={`${styles.PromptListSec}`}>
            <div className={`${styles.PromptList}`}>
              <div>
                <p className={`${styles.Title}`}>{callForward?.name}</p>
                <p className={`${styles.Des}`}>{callForward?.phone}</p>
                {callForward?.is_primary !== 1 && (<Switch
                  checked={callForward?.is_archived ? false : true}
                  onChange={(e) => handleToggle(e, callForward?.id)}
                  color="primary"
                  inputProps={{
                    "aria-label": "call forwarding switch",
                  }}
                  disabled={!isSMSChatCallforwardingUpdate}
                />)}
              </div>

              {callForward?.is_primary !== 1 && isSMSChatCallforwardingUpdate && (<button onClick={(e) => props.setDetails(callForward)} className={`${styles.PromptListEditBU}`}>
                <Edit />
              </button>)}

              {callForward?.is_primary !== 1 && isSMSChatCallforwardingDelete && (<button onClick={(e) => { props.setOpenCallForwardDeleteModal(true); props.setCallForwardId(callForward.id); }} className={`${styles.PromptListEditBU}`}>
                <Trash2 />
              </button>)}

              {callForward?.is_primary === 1 && (<Lock className={`${styles.TaskListLockIcon}`} />)}
            </div>
          </div>);
        })}

        {!props?.callForwardList?.length > 0 && (<div className={`${styles.NoDataMain}`}>
          <div className={`${styles.NoDataIMG}`}>
            <img src="/static/img/no-prospect.png" alt="No Data" />
          </div>
          <p className={`${styles.NoDataText}`}>Let's get started!</p>
          <p className={`${styles.NoDataTextSub}`}>Your number list is empty.</p>
        </div>)}
      </div>
    </DialogContent>
  </>);
};

export default CallForwardListing;